import request from '@/utils/request'; // 获取验证码

export function smsCodeGet(data) {
  return request({
    url: '/user/smscodeget',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 账号密码登陆

export function accountPasswordLogin(data) {
  return request({
    url: '/user/userlogin',
    method: 'post',
    data: data
  });
} // 验证码登录

export function smsCodeLogin(data) {
  return request({
    url: '/user/usersmslogin',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 退出登录

export function logingout() {
  return request({
    url: '/user/logingout',
    method: 'post'
  });
} // 登录后选择身份

export function queryDocType(data) {
  return request({
    url: '/user/querydoctype',
    method: 'post',
    data: data
  });
} // 存储所选身份

export function setDocType(data) {
  return request({
    url: '/user/setdoctype',
    method: 'post',
    data: data
  });
} // 个人信息

export function personalCenter(data) {
  return request({
    url: '/user/personalcenter',
    method: 'post',
    data: data
  });
} //修改个人中心基本信息

export function updateUserInfo(data) {
  return request({
    url: '/user/updateuserinfo',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 根据原账号密码修改账号密码

export function localupdatepassword(data) {
  return request({
    url: '/user/localupdatepassword',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 新建用户

export function saveUser(data) {
  return request({
    url: '/user/saveuserinfo',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 查询用户列表

export function userPage(data) {
  return request({
    url: '/user/queryuserinfo',
    method: 'post',
    data: data
  });
} // 查询医联体分页

export function muPage(data) {
  return request({
    url: '/user/querymedicalparter',
    method: 'post',
    data: data
  });
} // 查询医联体列表

export function muList(data) {
  return request({
    url: '/user/querymedicalparterlist',
    method: 'post',
    data: data
  });
} // 保存医联体（新增/修改）

export function saveMedicalparter(data) {
  return request({
    url: '/user/savemedicalparter',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 医院查询分页

export function hospitalPage(data) {
  return request({
    url: '/user/queryhospital',
    method: 'post',
    data: data
  });
} // 新建/修改医院

export function saveHospital(data) {
  return request({
    url: '/user/savehospital',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 根据医联体查询医院

export function hospitalList(data) {
  return request({
    url: '/user/queryhospitallist',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 用户角色列表

export function roleList(data) {
  return request({
    url: 'user/getrole',
    method: 'post',
    data: data
  });
} // 医联体角色列表

export function getmedicalroile(data) {
  return request({
    url: 'user/getmedicalroile',
    method: 'post',
    data: data
  });
} // 医院角色列表

export function gethospitalroile(data) {
  return request({
    url: 'user/gethospitalroile',
    method: 'post',
    data: data
  });
} // 获取角色类型

export function getaccouttype(data) {
  return request({
    url: 'user/getaccouttype',
    method: 'post',
    data: data
  });
} // 启用，停用，删除医院

export function edithospitalstate(data) {
  return request({
    url: 'user/edithospitalstate',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 启用，停用，删除医联体

export function editmedicalparterstate(data) {
  return request({
    url: 'user/editmedicalparterstate',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 启用，停用，删除用户

export function editdocstate(data) {
  return request({
    url: 'user/editdocstate',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改手机旧号码验证码

export function oldCodeGet(data) {
  return request({
    url: '/user/orignmobilesmscodeget',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改手机旧号码验证码校验

export function oldCodeCheck(data) {
  return request({
    url: '/user/orignsmscodecheck',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改手机新号码验证码

export function newCodeGet(data) {
  return request({
    url: '/user/newsmscodeget',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改手机新号码保存

export function newMobileSave(data) {
  return request({
    url: '/user/newmobilesave',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改密码获取验证码

export function newPswCode(data) {
  return request({
    url: '/user/updatepasssmscodeget',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改密码保存新密码

export function updatePass(data) {
  return request({
    url: '/user/updatepass',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} //个人中心修改机构信息

export function editAccountInfo(data) {
  return request({
    url: '/user/editaccountinfo',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 医院远程查询

export function queryhospitalbyname(data) {
  return request({
    url: 'user/queryhospitalbyname',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 医联体远程搜索

export function quermedicaparterbyname(data) {
  return request({
    url: 'user/quermedicaparterbyname',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 签名图片上传

export function postsign(data) {
  return request({
    url: '/user/postsign',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 保存签名图片　

export function editusersign(data) {
  return request({
    url: '/user/editusersign',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 判断是否有签名图片

export function usersignisexit() {
  return request({
    url: '/user/usersignisexit',
    method: 'post'
  });
} // 通用图片上传

export function uploadfile(data) {
  return request({
    url: 'user/uploadfile',
    contentType: 'multipart/form-data',
    method: 'post',
    data: data
  });
} // 字典

export function getdictonary(data) {
  return request({
    url: '/pat/getdictonary',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 根据影像类型查找检查部位

export function getdictonarybyparentid(data) {
  return request({
    url: '/pat/getdictonarybyparentid',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 关于我们

export function getproductinfo(data) {
  return request({
    url: '/user/getproductinfo',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 查询在线医生 

export function queryonlineuser(data) {
  return request({
    url: '/user/queryonlineuser',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 获取微信个人二维码

export function qrcodeget(data) {
  return request({
    url: '/user/qrcodeget',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
}
export function downloadlist(data) {
  return request({
    url: '/user/downloadlist',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
}
export function setparties(data) {
  return request({
    url: '/user/setparties',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
}
export function getparties(data) {
  return request({
    url: '/user/getparties',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
}
export function delaysofttime(data) {
  return request({
    url: '/user/delaysofttime',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
} // 获取有无外伤字典数据

export function getbinglijson() {
  return request({
    url: '/static/filedown?filename=bingli.json',
    method: 'get'
  });
}
export function shiftdoclist(data) {
  return request({
    url: '/user/shiftdoclist',
    contentType: 'application/x-www-form-urlencoded',
    method: 'post',
    data: data
  });
}